import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import API, { urlApiFlow } from "../../services/API";
import { TokenService } from "../../services/LocalStorage";
import { RootState } from "../store";
import { setRequestID } from "./RuleStore";
import { getAppModuleId } from "../../utils/AppModuleId";
import { toast } from "react-toastify";
import axios from "axios";

export interface ISelect {
  value: string;
  label: string;
}

//Se crea una interfaz unicamente para el nuevo metodo de los estados en requestLists
export interface SelectStatesNews {
  value: Array<string>;
  label: string;
}

interface Asset {
  CIID: string;
  CIName: string;
  Department: string;
  Impact: string;
  Location: string;
  UsedBy: string;
}

export interface AutofillDataType {
  UserLocationText?: string;
  UserLocationValue?: string;
  UserTowerText?: string;
  UserTowerValue?: string;
  UserFloorText?: string;
  UserFloorValue?: string;
  UserMail?: string;
  UserTelephone?: string;
  UserExtension?: string;
  UserDepartmentText?: string;
  UserDepartmentValue?: string;
}

interface Users {
  AuthUserID: string;
  CardID: string;
  Cellphone: string;
  CityID: string;
  CityName: string;
  CompanyID: string;
  CompanyName: string;
  CostCenterID: string;
  CostCenterName: string;
  CountryID: string;
  CountryName: string;
  DepartmentID: string;
  DepartmentName: string;
  DynamicSQL: string;
  Email: string;
  Extention: string;
  ExternalUser: string;
  Gender: string;
  HourCost: string;
  HoursMonth: string;
  IsSuperUser: string;
  IsVIP: string;
  LastName: string;
  LevelID: string;
  LocationID: string;
  LocationName: string;
  Name: string;
  Office: string;
  Phone: string;
  Phone2: string;
  PicturePath: string;
  PositionID: string;
  PositionName: string;
  StateID: string;
  StateName: string;
  StatusID: string;
  StatusName: string;
  TimeID: string;
  UpdatedOn: string;
  Username: string;
}

interface WorkOrder {
  ID?: string;
  ServiceOrderID?: string;
  Description?: string;
  Percentage?: string;
  TechnicianID?: string;
  StatusID?: string;
  StatusDescription?: string;
  TechnicianName?: string;
  TechnicianIsVIP?: string;
  IsPredecessor?: string;
  UserImage?: string;
  Advances: OrderAdvancement[];
  filesWorkOrder: FileAttach[];
}

export interface Request {
  requestId?: string;
  statusName?: string;
  closeDate?: string;
  creationDate?: string;
  description?: string;
  equipmentName?: string;
  errorTypeID?: string;
  errorTypeName?: string;
  expirationDate?: string;
  filingDate?: string;
  majorIncident?: string;
  natureCod?: string;
  natureID?: string;
  natureName?: string;
  onBehalfOfID?: string;
  onBehalfOfName?: string;
  priorityID?: string;
  problemTypeID?: string;
  problemTypeName?: string;
  receivedByID?: string;
  receivedByNames?: string;
  receptionDate?: string;
  reopenDate?: string;
  requestID: string;
  requestUserID?: string;
  requestUserNames?: string;
  statusID?: string;
  subject: string;
  surveyStatus?: string;
  vipStatus?: string;
  viaID?: string;
  viaName?: string;
  TechnicianName?: string;
  TechnicianImg?: any;
  pollQuestion?: any;
}

interface FullRequest {
  RequestID?: string;
  RequestUserID?: string;
  RequestUserNames?: string;
  RequestUserIsVIP?: string;
  ReceivedByID?: string;
  ReceivedByNames?: string;
  ReceivedByIsVIP?: string;
  ObBehalfOfID?: string;
  OnBehalfOfName?: string;
  ObBehalfOfEmail?: string;
  ObBehalfOfIsVIP?: string;
  CreationDate?: string;
  Description?: string;
  PriorityID?: string;
  StatusID?: string;
  StatusName?: string;
  Subject?: string;
  EquipmentName?: string;
  CloseDate?: string;
  ExpirationDate?: string;
  SurveyStatus?: string;
  FilingDate?: string;
  NatureID?: string;
  NatureName?: string;
  MajorIncident?: string;
  ReceptionDate?: string;
  ReopenDate?: string;
  VIPStatus?: string;
  NatureCod?: string;
  ViaID?: string;
  ViaName?: string;
  ProblemTypeID?: string;
  ProblemTypeName?: string;
  ErrorTypeID?: string;
  ErrorTypeName?: string;
  NatureTypeID?: string;
  NatureTypeName?: string;
  SLACode?: string;
  SLAName?: string;
  ObBehalfOfURLImage?: string;
  ServiceOrder?: ServiceOrder;
}

interface ServiceOrder {
  ActivityID?: string;
  ActivityName?: string;
  AreaID?: string;
  AreaName?: string;
  AssignmentDate?: string;
  CanBeReopened?: string;
  CategoryID?: string;
  CategoryName?: string;
  CloseDate?: string;
  Description?: string;
  ID?: string;
  ImpactID?: string;
  IsAccessFull?: string;
  PriorityID?: string;
  RFCID?: string;
  ServiceID?: string;
  ServiceName?: string;
  StatusID?: string;
  StatusName?: string;
  SurveyStatus?: string;
  TechnicianID?: string;
  TechnicianName?: string;
  UrgencyID?: string;
  WorkGroupID?: string;
  WorkGroupName?: string;
}

interface OrderAdvancement {
  AdvancementID: string;
  Description: string;
  EndDate: string;
  Environment: string;
  Progress: string;
  StartDate: string;
  Via: string;
  WorkOrderID: string;
}

interface Note {
  Description: string;
  ID: string;
  NoteDate: string;
  NoteTypeID: string;
  NoteTypeName: string;
  RequestID: string;
  UserID: string;
  UserImage: string;
  UserIsVIP: string;
  UserName: string;
}

interface FileAttach {
  AttachmentID: string;
  AttachmentPath: string;
  FileName: string;
  FileSize: string;
  FileURL: string;
}

interface RequestState {
  list: Request[];
  active: FullRequest;
  filteredList: Request[];
  pageData: Request[];
  rowsPerPage: number;
  workOrders: WorkOrder[];
  term: string;
  selectedYears: number[];
  selectedStatuses: number[];
  advancements: OrderAdvancement[];
  users: Users[];
  filteredUsers: ISelect[];
  createSuccess: boolean;
  areas: ISelect[];
  statesNew: SelectStatesNews[];
  departments: ISelect[];
  locations: ISelect[];
  torres: ISelect[];
  pisos: ISelect[];
  services: ISelect[];
  assets: Asset[];
  pagesTotal: number;
  offset: number;
  statuses: ISelect[];
  years: ISelect[];
  notesTypes: ISelect[];
  notes: Note[];
  page: number;
  files: FileAttach[];
  autofillData: AutofillDataType;
  workOrderId: string;
  selfServiceConfiguration: SelfServiceConfiguration;
  questionPoll: string;
}

export interface SelfServiceConfiguration {
  areVisibleFields?: boolean;
  areMandatoryFields?: boolean;
  ruleSelfService?: boolean;
  activateNewRequest?: boolean;
  activateMarketPlace?: boolean;
  activateExpirationDate?: boolean; // fechaVencimiento
}

export interface QuestionPoll {
  questionPoll?: string;
}

const initialState: RequestState = {
  list: [],
  active: {},
  filteredList: [],
  term: "",
  advancements: [],
  workOrders: [],
  filteredUsers: [],
  users: [],
  createSuccess: false,
  areas: [],
  statesNew: [
    { value: ["2", "11"], label: "Solucionados" },
    {
      value: ["4", "9", "3", "5", "12", "1", "6"],
      label: "Progreso",
    }
  ],
  departments: [],
  locations: [],
  torres: [],
  pisos: [],
  services: [],
  assets: [],
  pageData: [],
  rowsPerPage: 10,
  pagesTotal: 0,
  offset: 0,
  statuses: [],
  years: [],
  notesTypes: [],
  notes: [],
  selectedYears: [],
  selectedStatuses: [],
  page: 0,
  files: [],
  autofillData: {},
  workOrderId: "",
  questionPoll: "",
  selfServiceConfiguration: {
    areMandatoryFields: true,
    areVisibleFields: true,
    ruleSelfService: true,
    activateNewRequest: true,
    activateMarketPlace: true,
  }
};

export const RequestStore = createSlice({
  name: "request",
  initialState,
  reducers: {
    setRequests: (
      state: { list: Request[] },
      action: PayloadAction<Request[]>
    ) => {
      state.list = action.payload;
    },
    setWorkOrders: (
      state: { workOrders: WorkOrder[] },
      action: PayloadAction<WorkOrder[]>
    ) => {
      state.workOrders = action.payload;
    },
    setActiveRequest: (
      state: { active: FullRequest },
      action: PayloadAction<FullRequest>
    ) => {
      state.active = action.payload;
    },
    setFilteredRequests: (state: {
      list: any[];
      term: string;
      filteredList: any;
    }) => {
      const listFiltered = state.list.filter((e: { subject: string }) => {
        return e.subject.toLowerCase().indexOf(state.term.toLowerCase()) !== -1;
      });
      state.filteredList = listFiltered;
    },
    setRowsPerPage: (
      state: { rowsPerPage: number },
      action: PayloadAction<number>
    ) => {
      state.rowsPerPage = action.payload;
    },
    setCurrentPageData: (
      state: { list: string | any[]; pageData: any, rowsPerPage: number },
      action: PayloadAction<number>
    ) => {
      const startIndex = (action.payload - 1) * state.rowsPerPage;
      const endIndex = startIndex + state.rowsPerPage;
      const newData = state.list.slice(action.payload, action.payload + state.rowsPerPage);
      // const newData = state.list.slice(startIndex, endIndex);
      state.pageData = newData;
    },
    setTerm: (state: { term: string }, action: PayloadAction<string>) => {
      state.term = action.payload;
    },
    setSelectedYears: (
      state: { selectedYears: number[] },
      action: PayloadAction<number[]>
    ) => {
      state.selectedYears = action.payload;
    },
    setSelectedStatuses: (
      state: { selectedStatuses: number[] },
      action: PayloadAction<number[]>
    ) => {
      state.selectedStatuses = action.payload;
    },
    setAdvancements: (
      state: { advancements: OrderAdvancement[] },
      action: PayloadAction<OrderAdvancement[]>
    ) => {
      state.advancements = action.payload;
    },
    setFilteredUsers: (
      state: { filteredUsers: ISelect[] },
      action: PayloadAction<ISelect[]>
    ) => {
      state.filteredUsers = action.payload;
    },
    setUsers: (state: { users: Users[] }, action: PayloadAction<Users[]>) => {
      state.users = action.payload;
    },
    createSuccess: (
      state: { createSuccess: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.createSuccess = action.payload;
    },
    setAreas: (
      state: { areas: ISelect[] },
      action: PayloadAction<ISelect[]>
    ) => {
      state.areas = action.payload;
    },
    setDepartments: (
      state: { departments: ISelect[] },
      action: PayloadAction<ISelect[]>
    ) => {
      state.departments = action.payload;
    },
    setLocations: (
      state: { locations: ISelect[] },
      action: PayloadAction<ISelect[]>
    ) => {
      state.locations = action.payload;
    },
    setTorres: (
      state: { torres: ISelect[] },
      action: PayloadAction<ISelect[]>
    ) => {
      state.torres = action.payload;
    },
    setPisos: (
      state: { pisos: ISelect[] },
      action: PayloadAction<ISelect[]>
    ) => {
      state.pisos = action.payload;
    },
    setSelfServiceConfiguration: (
      state: { selfServiceConfiguration: SelfServiceConfiguration },
      action: PayloadAction<SelfServiceConfiguration>
    ) => {
      state.selfServiceConfiguration = action.payload;
    },
    setServices: (
      state: { services: ISelect[] },
      action: PayloadAction<ISelect[]>
    ) => {
      state.services = action.payload;
    },
    setAssets: (state: { assets: Asset[] }, action: PayloadAction<Asset[]>) => {
      state.assets = action.payload;
    },
    setTotalPages: (
      state: { pagesTotal: number },
      action: PayloadAction<number>
    ) => {
      state.pagesTotal = action.payload;
    },
    setStatuses: (
      state: { statuses: ISelect[] },
      action: PayloadAction<ISelect[]>
    ) => {
      state.statuses = action.payload;
    },
    setStatesNew: (
      state: { statesNew: SelectStatesNews[] },
      action: PayloadAction<SelectStatesNews[]>
    ) => {
      state.statesNew = action.payload;
    },
    setYears: (
      state: { years: ISelect[] },
      action: PayloadAction<ISelect[]>
    ) => {
      state.years = action.payload;
    },
    setNotesTypes: (
      state: { notesTypes: ISelect[] },
      action: PayloadAction<ISelect[]>
    ) => {
      state.notesTypes = action.payload;
    },
    setNotes: (state: { notes: Note[] }, action: PayloadAction<Note[]>) => {
      state.notes = action.payload;
    },
    setPage: (state: { page: number }, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setFiles: (
      state: { files: FileAttach[] },
      action: PayloadAction<FileAttach[]>
    ) => {
      state.files = action.payload;
    },
    setAutofillData: (
      state: { autofillData: AutofillDataType },
      action: PayloadAction<AutofillDataType>
    ) => {
      state.autofillData = action.payload;
    },
    setWorkOrderId: (
      state: { workOrderId: string },
      action: PayloadAction<string>
    ) => {
      state.workOrderId = action.payload;
    },
    setQuestionPoll: (
      state: { questionPoll: string },
      action: PayloadAction<string>
    ) => {
      state.questionPoll = action.payload;
    },
    cleanStore: () => {
      return { ...initialState };
    },
  },
});

export const setAutofillRequestData = () => async (dispatch: any) => {
  try {
    API()
      .get(`users/GetUserBasicInformation?token=${TokenService.get()}`)
      .then((response) => {
        let autofillData: AutofillDataType = {};
        autofillData["UserLocationText"] = response.data.Value.UserLocationText;
        autofillData["UserLocationValue"] =
          response.data.Value.UserLocationValue;
        autofillData["UserMail"] = response.data.Value.UserMail;
        autofillData["UserTelephone"] = response.data.Value.UserTelephone;
        autofillData["UserExtension"] = response.data.Value.UserExtension;
        autofillData["UserDepartmentText"] =
          response.data.Value.UserDepartmentText;
        autofillData["UserDepartmentValue"] =
          response.data.Value.UserDepartmentValue;
        autofillData["UserTowerText"] = response.data.Value.UserTowerText;
        autofillData["UserTowerValue"] = response.data.Value.UserTowerValue;
        autofillData["UserFloorText"] = response.data.Value.UserFloorText;
        autofillData["UserFloorValue"] = response.data.Value.UserFloorValue;
        dispatch(setAutofillData(autofillData));
      });
  } catch (e: any) {
    return console.error(e.message);
  }
};

export const getAreas = (username: string) => async (dispatch: any) => {
  try {
    API()
      .get(`services/getareas?token=${TokenService.get()}&username=${username}`)
      .then((response) => {
        let areas: ISelect[] = [];
        response.data.Values.forEach((e: any) => {
          areas.push({ value: e.Value, label: e.Text });
        });
        dispatch(setAreas(areas));
      });
  } catch (e: any) {
    return console.error(e.message);
  }
};

export const rateRequest =
  (
    RequestCode: number,
    isUseful: boolean,
    hasComplaint: boolean,
    observations: string,
    questionsCalifications: number[]
  ) =>
    async (dispatch: any) => {
      let result = "";

      return API()
        .post(`knowledge/RateSurvey`, {
          RequestCode: RequestCode,
          isUseful: isUseful,
          hasComplaint: hasComplaint,
          observations: observations,
          questionsCalifications: questionsCalifications,
          token: TokenService.get(),
        })
        .then((response) => {
          result = response.data.status;
          // console.log(response.data.Reopen);
          if (response.data.Reopen === 'no') {
            toast.warning('No se ha logrado reaabrir la solicitud porque se excedio el tiempo limite', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else if (response.data.Reopen === 'si') {
            toast.success('Se reabrio la solicitud correctamente', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              className: "create-reuqest-success",
            });
          }



          dispatch(getActiveRequest(RequestCode.toString()));

        })
        .catch((e) => {
          console.error(e);
          toast.warning('Error al reabrir la solicitud ', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
    };

export const getServices =
  (username: string, areaId: string) => async (dispatch: any) => {
    try {
      API()
        .get(
          `services/getservices?token=${TokenService.get()}&areaid=${areaId}&username=${username}`
        )
        .then((response) => {
          let areas: ISelect[] = [];
          response.data.Values.forEach((e: any) => {
            areas.push({ value: e.Value, label: e.Text });
          });
          dispatch(setServices(areas));
        });
    } catch (e: any) {
      return console.error(e.message);
    }
  };

export const getStatuses = () => async (dispatch: any) => {
  try {
    API()
      .get(`services/GetServiceOrderStatus?token=${TokenService.get()}`)
      .then(() => {
        let statusNew: SelectStatesNews[] = [];

        statusNew.push({
          value: ["4", "9", "3", "5", "12", "1", "6"],
          label: "Progreso",
        });
        statusNew.push({ value: ["2", "11"], label: "Solucionados" });

        dispatch(setStatesNew(statusNew));
      });
  } catch (e: any) {
    return console.error(e.message);
  }
};

export const getNoteTypes = () => async (dispatch: any) => {
  try {
    API()
      .get(`services/getnotetypes?token=${TokenService.get()}`)
      .then((response) => {
        let areas: ISelect[] = [];
        response.data.Values.forEach((e: any) => {
          if (e.Visible === true) {
            areas.push({ value: e.Value, label: e.Text });
          }
        });
        dispatch(setNotesTypes(areas));
      });
  } catch (e: any) {
    return console.error(e.message);
  }
};

export const getYears = (username: string) => async (dispatch: any) => {
  try {
    API()
      .get(
        `services/GetRequests?token=${TokenService.get()}&userSearched=${username ?? ""
        }&optionsID=[2]&appModule=${getAppModuleId()}`
      )
      .then((response) => {
        const dates: number[] = [];
        response.data.Values.forEach((requestItem: any) => {
          const date = new Date(requestItem.ReceptionDate);
          dates.push(date.getFullYear());
        });
        let result = dates.filter((item, index) => {
          return dates.indexOf(item) === index;
        });
        const datesSelect: ISelect[] = [];
        result.sort().forEach((e) => {
          datesSelect.push({ value: e.toString(), label: e.toString() });
        });
        dispatch(setYears(datesSelect));
      });
  } catch (e: any) {
    return console.error(e.message);
  }
};

export const getWorkerOrderID = async (RequestID: string) => {
  return API()
    .get(
      `services/getrequestwithorder?token=${TokenService.get()}&requestid=${RequestID}`
    )
    .then((response) => {
      return response.data.Values.ServiceOrder.ID;
    })
    .catch((e) => {
      return e;
    });
};

export const getWorker = async (RequestID: string) => {
  const workOderID = await getWorkerOrderID(RequestID);
  const UserName = "";
  return await API()
    .get(
      `services/getworkorders?token=${TokenService.get()}&serviceorderid=${workOderID}&ModuloId=4`
    )
    .then((res) => {
      return res.data.Values.length > 0 ? res.data.Values[0].UserImage : "";
    })
    .catch((e) => {
      return e;
    });
};



export const getRequests =
  (username: string, page?: number) => async (dispatch: any) => {
    const today: Date = new Date();
    // const currentMonth: string = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    const currenYear: number = today.getFullYear();
    try {
      await API()
        .get(
          `services/GetRequests?token=${TokenService.get()}&year=${getCurrentPreviousYear()}&month=[01,02,03,04,06,07,08,09,10,11,12]&serviceOrderStatusID=[1,2,3,4,5,6,9,11,12]&userSearched=${username ?? ""
          }&optionsID=[2]&appModule=${getAppModuleId()}`
        )
        .then(async (response) => {
          let data: Request[] = [];

          data = await Promise.all(
            response.data.Values.map(async (requestItem: any) => {
              let newItem = {
                requestID: requestItem.RequestID,
                subject: requestItem.Subject,
                statusName: requestItem.StatusName,
                receptionDate: requestItem.ReceptionDate,
                viaName: requestItem.ViaName,
                TechnicianName: requestItem.TechnicianName,
                TechnicianImg: "",
              };
              return newItem;
            })
          );

          dispatch(setRequests(data));
          dispatch(setRequestID(""));

          let offset = 0;
          if (page) offset = page;

          dispatch(setTotalPages(data.length));
          dispatch(setCurrentPageData(offset));
        });
    } catch (e: any) {
      return console.error(e.message);
    }
  };

const getCurrentPreviousYear = () => {
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;

  return `[${previousYear}], [${currentYear}]`;
}


export const getActiveRequest =
  (requestId: string) => async (dispatch: any) => {
    try {
      API()
        .get(
          `services/GetRequestWithOrderSync?token=${TokenService.get()}&requestid=${requestId}`
        )
        .then((response) => {
          dispatch(setActiveRequest(response.data.Values));
          dispatch(getOrdersWorks(response.data.Values.ServiceOrder.ID));
          dispatch(getFilesByRequest(requestId));
          dispatch(getAssetsByRequest(requestId));
          dispatch(getNoteTypes());
          dispatch(getNotesByRequest(requestId));
          dispatch(setRequestID(""));
        });
      return;
    } catch (e: any) {
      return console.error(e.message);
    }
  };

export const getOrdersWorks = (serviceID: number) => async (dispatch: any) => {
  return await API()
    .get(
      `services/getworkorders?token=${TokenService.get()}&serviceorderid=${serviceID}&moduloid=${"4"}`
    )
    .then(async (response) => {
      let workOrders: any[] = [];
      for (const element of response.data.Values) {
        const workOrder: WorkOrder = { ...element, Advances: [] };
        const workOderID = workOrder.ID;
        const advances = await getOrderAdvancementsWork(
          workOderID ? workOderID : "0"
        );
        const uploadedFiles = await getFilesByWorkOrder(
          workOderID ? workOderID : "0"
        );
        workOrder.Advances = advances;
        workOrder.filesWorkOrder = uploadedFiles;
        workOrders.push(workOrder);
      }

      dispatch(setWorkOrders(workOrders));
      dispatch(getFilesByWorkOrder('38802'))
    })
    .catch((e) => {
      return console.error(e.message);
    });
};

export const getOrderAdvancementsWork = async (workOrderId: string) => {
  return API()
    .get(
      `services/getworkorderadvancements?token=${TokenService.get()}&workorderid=${workOrderId}`
    )
    .then((response) => {
      const regex = /style="[^"]*"/g;
      let descriptionOt = response.data.Values.map((a: any) => {
        return { ...a, Description: a.Description.replace(regex, "") };
      });

      return descriptionOt;
    });
};

export const getAssetsByRequest =
  (requestId: string) => async (dispatch: any) => {
    try {
      API()
        .get(
          `assets/GetAssetsByRequest?token=${TokenService.get()}&requestid=${requestId}`
        )
        .then((response) => {
          dispatch(setAssets(response.data.Values));
        });
    } catch (e: any) {
      return console.error(e.message);
    }
  };

export const getFilesByRequest =
  (requestId: string) => async (dispatch: any) => {
    try {
      API()
        .get(
          `file/GetAttachmentsListRequest?token=${TokenService.get()}&requestid=${requestId}`
        )
        .then((response) => {
          dispatch(setFiles(response.data.Values));
        });
    } catch (e: any) {
      return console.error(e.message);
    }
  };


export const getFilesByWorkOrder = async (workOrderId: string) => {
  return API()
    .get(
      `file/GetAttachmentsListWorkOrder?token=${TokenService.get()}&workOrderId=${workOrderId}`
    )
    .then((response) => {

      return response.data.Values;

    });
};

export const getNotesByRequest =
  (requestId: string) => async (dispatch: any) => {
    return await API()
      .get(
        `services/getnotes?token=${TokenService.get()}&RequestID=${requestId}`
      )
      .then((response) => {
        dispatch(setNotes(response.data.Values));
      });
  };

export const setCurrentData = (offset: number) => async (dispatch: any) => {
  dispatch(setCurrentPageData(offset));
};

export const createNote =
  (requestID: string, text: string, noteType: string) =>
    async (dispatch: any) => {
      return await API()
        .post(`services/insertnote`, {
          Token: TokenService.get(),
          RequestID: requestID,
          Description: text,
          NoteTypeID: noteType,
        })
        .then((response) => {
          dispatch(getNotesByRequest(requestID));
        })
        .catch((e) => {
          return console.error(e.message);
        });
    };

export const getFilteredRequests =
  (
    username: string,
    status: number[],
    years: number[],
    page?: number,
    months?: number[]
  ) =>
    async (dispatch: any) => {
      var today = new Date();
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      const lastTwoMonths = (month: string) => {
        let monthList: string[] = [month];
        let prev = parseInt(month) === 1 ? 12 : parseInt(month) - 1;
        monthList.push(prev.toString());
        return monthList.join(",");
      };

      let filter = "";
      if (status.length > 0) {
        filter = `&serviceOrderStatusID=${status}`;
      }

      let filterYear = "";

      if (years.length > 0) {
        filter = `&year=${years}`;
      } else {
        filter = `&year=${yyyy}`;
      }

      let filterMonth = "";

      if (months && months.length > 0) {
        filterMonth = `&month=${months}`;
      } else {
        filterMonth = `&month=${lastTwoMonths(mm)}`;
      }

      if (!username) {
        username = "";
      }

      try {
        API()
          .get(
            `services/GetRequests?token=${TokenService.get()}${filterYear}${filter}${filterMonth}&userSearched=${username}&optionsID=[2]&appModule=${getAppModuleId()}`
          )
          .then(async (response) => {
            let data: Request[] = [];
            data = await Promise.all(
              response.data.Values.map(async (requestItem: any) => {
                let newItem = {
                  requestID: requestItem.RequestID,
                  subject: requestItem.Subject,
                  statusName: requestItem.StatusName,
                  receptionDate: requestItem.ReceptionDate,
                  viaName: requestItem.ViaName,
                  TechnicianName: requestItem.TechnicianName,
                  TechnicianImg: "",
                  // TechnicianImg: await getWorker(requestItem.RequestID),
                };
                return newItem;
              })
            );
            dispatch(setRequests(data));
            let offset = 0;
            if (page) offset = page;
            dispatch(setTotalPages(data.length));
            dispatch(setCurrentPageData(offset));
          });
      } catch (e: any) {
        return console.error(e.message);
      }
    };

export const testFilter =
  (
    username: string,
    status: number[],
    years: number[],
    term: string,
    code: string,
    month?: string[],
    page?: number,
    timeFilterOption?: number,
    customFirstDate?: string | Date,
    customSecondDate?: string | Date
  ) =>
    async (dispatch: any) => {


      let filter = "";

      if (status.length > 0) {
        filter = `&serviceOrderStatusID=[${status}]`;
      }



      let filterYear = "";

      if (years.length > 0) {
        filterYear = `&year=[${years.join()}]`;
      }

      let filterTerm = "";

      if (term !== "") {
        filterTerm = `&subject=${term}`;
      }

      let filterCode = "";

      if (code !== "") {
        filterCode = `&requestID=${code}`;
      }

      let filterMonth = "";

      if (month) {
        filterMonth = `&month=[${month}]`;
      }

      if (!username) {
        username = "";
      }

      if (customFirstDate instanceof Date) {
        customFirstDate = customFirstDate.toLocaleDateString();
      }

      if (customSecondDate instanceof Date) {
        customSecondDate = customSecondDate.toLocaleDateString();



      }

      try {
        await API()
          .get(
            `services/GetRequests?token=${TokenService.get()}${filterYear}${filter}${filterTerm}${filterMonth}${filterCode}&timeFilterOption=${timeFilterOption}&customFirstDate=${customFirstDate}&customSecondDate=${customSecondDate}&userSearched=${username}&optionsID=[2]&appModule=${getAppModuleId()}`
          )
          .then(async (response) => {
            let data: Request[] = [];
            data = await Promise.all(
              response.data.Values.map(async (requestItem: any) => {
                let newItem = {
                  requestID: requestItem.RequestID,
                  subject: requestItem.Subject,
                  statusName: requestItem.StatusName,
                  receptionDate: requestItem.ReceptionDate,
                  viaName: requestItem.ViaName,
                  TechnicianName: requestItem.TechnicianName,
                  TechnicianImg: "",
                };
                return newItem;
              })
            );
            dispatch(setRequests(data));
            let offset = 0;
            if (page) offset = page;
            dispatch(setTotalPages(data.length));
            dispatch(setCurrentPageData(offset));
          });
      } catch (e: any) {
        return console.error(e.message);
      }
    };

export const filterByStatuses = (term: number[]) => async (dispatch: any) => {
  dispatch(setSelectedStatuses(term));
};

export const filterByYears = (term: number[]) => async (dispatch: any) => {
  dispatch(setSelectedYears(term));
};

export const filterByTerm = (term: string) => async (dispatch: any) => {
  dispatch(setTerm(term));
};

export const filterByPage = (term: number) => async (dispatch: any) => {
  dispatch(setPage(term));
};

export const filterRequests =
  (username: string, status: number[], years: number[], page?: number) =>
    async (dispatch: any) => {
      let filter = "";

      if (status.length > 0) {
        filter = `&serviceOrderStatusID=${status}`;
      }

      let filterYear = "";

      if (years.length > 0) {
        filter = `&year=${years}`;
      }

      if (!username) {
        username = "";
      }

      try {
        API()
          .get(
            `services/GetRequests?token=${TokenService.get()}${filterYear}${filter}&userSearched=${username}&optionsID=[2]&appModule=${getAppModuleId()}`
          )
          .then((response) => {
            const data: Request[] = [];
            response.data.Values.forEach((requestItem: any) => {
              data.push({
                requestID: requestItem.RequestID,
                subject: requestItem.Subject,
                statusName: requestItem.StatusName,
                receptionDate: requestItem.ReceptionDate,
                viaName: requestItem.ViaName,
                TechnicianName: requestItem.TechnicianName,
              });
            });
            dispatch(setRequests(data));
            let offset = 0;
            if (page) offset = page;
            dispatch(setTotalPages(data.length));
            dispatch(setCurrentPageData(offset));
          });
      } catch (e: any) {
        return console.error(e.message);
      }
    };

// New Request
export const getDepartments = () => async (dispatch: any) => {
  try {
    API()
      .get(
        `users/getdepartments?token=${TokenService.get()}
        `
      )
      .then((response) => {
        let departments: ISelect[] = [];
        response.data.Values.map((department: any) => {
          if (department.Text !== "") {
            departments.push({
              value: department.Value,
              label: department.Text,
            });
          }
          return null;
        });
        dispatch(setDepartments(departments));
      });
  } catch (error) {
    console.error(error);
  }
};

export const getTorres = (companyId: string) => async (dispatch: any) => {
  try {
    API()
      .get(
        `services/GetTorres?token=${TokenService.get()}&companyId=${Number.parseInt(
          companyId
        )}`
      )
      .then((response: any) => {
        let torres: ISelect[] = [];

        response.data.Values.map((towersResponse: any) => {
          if (towersResponse.TorreNombre !== "") {
            torres.push({
              value: towersResponse.TorreCod,
              label: towersResponse.TorreNombre,
            });
          }

          return null;
        });

        dispatch(setTorres(torres));
      });
  } catch (error: unknown) {
    console.error("[Request Store] - Error de servicio getTorres", error);
  }
};

export const getPisos = (towerId: string) => async (dispatch: any) => {
  try {
    API()
      .get(
        `services/GetPisos?token=${TokenService.get()}&towerId=${Number.parseInt(
          towerId
        )}`
      )
      .then((floorsResponse: any) => {
        let pisos: ISelect[] = [];

        floorsResponse.data.Values.map((floor: any) => {
          if (floor.PisoNombre !== "") {
            pisos.push({
              label: floor.PisoNombre,
              value: floor.PisoCod,
            });
          }
          return null;
        });

        dispatch(setPisos(pisos));
      });
  } catch (error: unknown) {
    console.error("[Request Store] - Error de servicio getPisos", error);
  }
};

export const getSelfServiceConfiguration = (loadingSetFunction?: Function) => async (dispatch: any) => {
  try {
    API()
      .get(`services/configuration/confHelp?token=${TokenService.get()}`)
      .then((response: any) => {
        let configuration: SelfServiceConfiguration = {
          areVisibleFields: response.data.Values.SelfServVisible,
          areMandatoryFields: response.data.Values.SelfServActivo,
          ruleSelfService: response.data.Values.ReglaSelfService,
          activateNewRequest: response.data.Values.confActivarNuevasolSelf,
          activateMarketPlace: response.data.Values.confActivarMarketSelf,
          activateExpirationDate: response.data.Values.confActivarFechaVencSelf, // fechaVencimiento
        };

        dispatch(setSelfServiceConfiguration(configuration));
        if (loadingSetFunction) {
          loadingSetFunction(false)
        }
      });
  } catch (getConfigurationError) {
    console.error(
      "[RequestStore] getSelfServiceConfiguration ",
      getConfigurationError
    );
  }
};

export const getLocations = (companyid: string) => async (dispatch: any) => {
  try {
    API()
      .get(
        `users/GetLocations?token=${TokenService.get()}&companyid=${companyid}`
      )
      .then((response) => {
        let Locations: ISelect[] = [];
        response.data.Values.map((location: any) => {
          if (location.Text !== "") {
            Locations.push({ value: location.Value, label: location.Text });
          }
          return null;
        });
        dispatch(setLocations(Locations));
      });
  } catch (error) {
    console.error(error);
  }
};

export const getUsers =
  (companyId: string, usernameOrNames: string = "") =>
    async (dispatch: any) => {
      try {
        let url: string = `users/getusers?token=${TokenService.get()}&State=1&companyID=${companyId}`;

        if (usernameOrNames !== "") {
          url = url.concat(`&usernameOrNames=${usernameOrNames}`);
        }

        API()
          .get(url)
          .then((response) => {
            let filteredUsers: ISelect[] = [];
            let users: Users[] = [];

            response.data.Values.map((user: any) => {
              const filteredUser: ISelect = {
                label: user.Name + " " + user.LastName,
                value: user.CompanyID + " " + user.Username,
              };

              filteredUsers.push(filteredUser);
              users.push(user);

              return null;
            });

            dispatch(setFilteredUsers(filteredUsers));
            dispatch(setUsers(users));
          });
      } catch (error) {
        console.error(error);
      }
    };

export const saveFiltersGrid =
  (
    selectStateNew: string[],
    optionsSearch: any,
    searchCriteria: string,
    filterDays: any,
    firtsDate: string,
    secondDate: string
  ) =>
    async () => {
      let filters: any = {
        GridName: "REQUEST_GRID",
        Token: TokenService.get(),
        ModuleId: 4,
      };

      if (selectStateNew.length > 0) {
        filters.statusNew = JSON.stringify(selectStateNew);
      }

      if (optionsSearch) {
        filters.filterSearchOption = optionsSearch;
      }

      if (searchCriteria !== "") {
        filters.searchCriteria = searchCriteria;
      }

      if (filterDays && filterDays.value) {
        filters.TimeFilterOption = filterDays.value;
      }

      if (firtsDate) {
        filters.customFirstDate = firtsDate;
      }

      if (secondDate) {
        filters.customSecondDate = secondDate;
      }

      return await API()
        .post(`/users/SaveFiltersGrid`, filters)
        .then(() => { })
        .catch((e: unknown) => { });
    };

export const deleteSavedFilters = () => async () => {
  const payload = {
    token: TokenService.get(),
    gridName: "REQUEST_GRID",
    moduleId: 4,
  };

  return await API()
    .post(`/users/DeleteFiltersGrid`, payload)
    .then(() => { })
    .catch((e: unknown) => { });
};

export const getQuestion = () => async (dispatch: any) => {
  try {
    API()
      .get(`services/GetPregunta?token=${TokenService.get()}&id=${1}`)
      .then((response) => {
        let question = response.data.Values;
        dispatch(setQuestionPoll(question));
      });
  } catch (e: any) {
    return console.error(e.message);
  }
};

export const getLanguage = (username: string) => async () => {
  try {
    const url = `${urlApiFlow}/Flow/language?username=${username}`;
    return await API().get(url);
  } catch (e: any) {
    return console.error(e.message);
  }
};

export const getParameter = async (body: any) => {
  try {
    const url = `${urlApiFlow}/Flow/getParam`;
    return await API().post(url, body)
  } catch (error) {
    return console.error(error);
  }
}

export const {
  setRequests,
  setActiveRequest,
  setFilteredRequests,
  setWorkOrders,
  setTerm,
  setAdvancements,
  setFilteredUsers,
  setUsers,
  createSuccess,
  setAreas,
  setServices,
  setAssets,
  setCurrentPageData,
  setTotalPages,
  setStatuses,
  setStatesNew,
  setYears,
  setNotesTypes,
  setNotes,
  setSelectedYears,
  setSelectedStatuses,
  setPage,
  setFiles,
  setDepartments,
  setLocations,
  setAutofillData,
  setWorkOrderId,
  setTorres,
  setPisos,
  setSelfServiceConfiguration,
  cleanStore,
  setQuestionPoll,
  setRowsPerPage
} = RequestStore.actions;
export const request = (state: RootState) => state.request;
export default RequestStore.reducer;
